import { Table } from 'antd';
import { TablePaginationConfig, TableProps } from 'antd/es/table';
import { useEffect, useState } from 'react';

const TableComponent = <T extends object>(props: TableProps<T>) => {
  const {
    columns,
    dataSource = [],
    onChange,
    loading = false,
    rootClassName = '',
    pagination,
    scroll,
    sticky,
    footer,
    locale,
    ...rest
  } = props;

  const [paginationProps, setPaginationProps] = useState<TablePaginationConfig>(
    {
      pageSizeOptions: [10, 15, 20, 50, 100],
      defaultPageSize: 10,
      responsive: true,
      showSizeChanger: true,
      position: ['bottomCenter'],
    },
  );

  useEffect(() => {
    if (pagination) {
      setPaginationProps({
        ...paginationProps,
        ...pagination,
      } as TablePaginationConfig);
    }
  }, [pagination]);

  return (
    <Table
      columns={columns}
      bordered={false}
      dataSource={dataSource}
      className={rootClassName}
      onChange={onChange}
      pagination={pagination ? paginationProps : false}
      loading={loading}
      scroll={scroll}
      sticky={sticky}
      footer={footer}
      locale={locale}
      {...rest}
    />
  );
};

export default TableComponent;
